import React, { Component } from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import { saveMembers, startUpload, stopUpload, clearAjaxCall, saveMembersFailure } from '../../actions/Members'

import Modal from '../Modal'
import { countries } from '../../geo.json'
import { sexTypes, tshirtSizes } from '../../options.json'

class EditMember extends Component {
  constructor () {
    super()
    this._handleImageChange = this._handleImageChange.bind(this)
    this._handleAvatarChange = this._handleAvatarChange.bind(this)
    this._handleBlur = this._handleBlur.bind(this)
  }
  saveMembers () {
    const m = this.state
    if (m.name !== '' &&
      m.surname !== '' &&
      m.city !== '' &&
      m.address !== '' &&
      m.country !== '' &&
      m.fiscal_code !== '' &&
      m.born_date !== '') {
      if (m.age < 18 && m.tutor_id === '') {
        this.props.saveMembersFailure('Assegnare tutore legale')
        setTimeout(() => { this.props.clearAjaxCall('') }, 3000)
      } else {
        this.props.saveMembers({
          id: m.id,
          name: m.name,
          surname: m.surname,
          sex: m.sex,
          email: m.email,
          postal_code: m.postal_code,
          city: m.city,
          address: m.address,
          country: m.country,
          born_date: (m.born_date !== '') ? moment.utc(m.born_date).startOf('day').unix() : '',
          born_city: m.born_city,
          born_country: m.born_country,
          fiscal_code: m.fiscal_code,
          tutor_id: m.tutor_id,
          tshirt_size: m.tshirt_size,
          phone: m.phone,
          mobile: m.mobile,
          notes: m.notes,
          course_id: m.course_id,
          insurance_date: (m.insurance_date !== '') ? moment.utc(m.insurance_date).startOf('day').unix() : '',
          medical_certificate: (m.medical_certificate !== '') ? moment.utc(m.medical_certificate).startOf('day').unix() : '',
          doc: m.doc,
          doc_name: m.doc_name,
          doc_delete: m.doc_delete,
          avatar: m.avatar,
          title: m.title
        })
      }
    } else {
      this.props.saveMembersFailure('Verificare i dati obbligatori')
      setTimeout(() => { this.props.clearAjaxCall('') }, 3000)
    }
  }
  _handleAvatarChange (e) {
    e.preventDefault()
    let reader = new window.FileReader()
    if (e.target.files.length > 0) {
      let file = e.target.files[0]
      this.props.startUpload()
      reader.onloadend = () => {
        this.setState({
          avatar: reader.result
        })
        this.props.stopUpload()
      }
      reader.readAsDataURL(file)
    } else {
      this.setState({
        avatar: ''
      })
    }
  }
  _handleImageChange (e) {
    e.preventDefault()
    let reader = new window.FileReader()
    if (e.target.files.length > 0) {
      let file = e.target.files[0]
      this.props.startUpload()
      reader.onloadend = () => {
        this.setState({
          doc: reader.result,
          doc_name: file.name,
          doc_delete: true,
          doc_delete_lock: true
        })
        this.props.stopUpload()
      }
      reader.readAsDataURL(file)
    } else {
      this.setState({
        doc: '',
        doc_delete: false,
        doc_name: '',
        doc_delete_lock: false
      })
    }
  }
  componentWillMount () {
    const m = this.props.member
    this.setState({
      id: m.id,
      name: m.name,
      surname: m.surname,
      sex: m.sex,
      email: m.email,
      postal_code: m.postal_code,
      city: m.city,
      address: m.address,
      country: m.country,
      born_date: (m.born_date !== '') ? moment.unix(m.born_date).format('YYYY-MM-DD') : '',
      age: m.age,
      born_city: m.born_city,
      born_country: m.born_country,
      fiscal_code: m.fiscal_code,
      tutor_id: m.tutor_id,
      tshirt_size: m.tshirt_size,
      phone: m.phone,
      mobile: m.mobile,
      notes: m.notes,
      course_id: m.course_id,
      insurance_date: (m.insurance_date !== '') ? moment.unix(m.insurance_date).format('YYYY-MM-DD') : '',
      medical_certificate: (m.medical_certificate !== '') ? moment.unix(m.medical_certificate).format('YYYY-MM-DD') : '',
      medical_certificate_doc: m.medical_certificate_doc,
      doc_name: '',
      medical_certificate_checksum: m.medical_certificate_checksum,
      doc_delete: false,
      doc_delete_lock: false,
      avatar: '',
      title: m.title
    })
  }
  _handleBlur () {
    this.setState({ age: moment().diff(this.state.born_date, 'years') })
  }
  render () {
    const { list, ajaxStatus } = this.props.members
    const m = this.state
    return (
      <Modal>
        <h3>{(m.id !== null) ? 'Modifica' : 'Aggiungi'} anagrafica</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 className="first">Informazioni obbligatorie</h4>
        <label>
            Nome
          <input
            type="text"
            placeholder="Nome"
            onChange={event => this.setState({ name: event.target.value })}
            value={m.name}
          />
        </label>
        <label>
            Cognome
          <input
            type="text"
            placeholder="Cognome"
            onChange={event => this.setState({ surname: event.target.value })}
            value={m.surname}
          />
        </label>
        <label>
          Città
          <input
            type="text"
            placeholder="Città"
            onChange={event => this.setState({ city: event.target.value })}
            value={m.city}
          />
        </label>
        <label>
          Indirizzo
          <input
            type="text"
            placeholder="Indirizzo"
            onChange={event => this.setState({ address: event.target.value })}
            value={m.address}
          />
        </label>
        <label>
          Provincia
          <select
            onChange={event => this.setState({ country: event.target.value })}
            value={m.country}
          >
            <option value=""></option>
            {
              countries.map((c, index) => {
                return (
                  <option key={index} value={c.value}>
                    {c.label}
                  </option>
                )
              })
            }
          </select>
        </label>
        <label>
            Codice fiscale
          <input
            type="text"
            placeholder="Codice fiscale"
            onChange={event => this.setState({ fiscal_code: event.target.value })}
            value={m.fiscal_code}
          />
        </label>
        <label>
            Data di nascita
          <input
            type="date"
            placeholder="Data di nascita"
            onChange={event => this.setState({ born_date: event.target.value })}
            value={m.born_date}
            onBlur={this._handleBlur}
          />
        </label>
        <label>
          Età
          <span className="age">{m.age}&nbsp;</span>
        </label>
        <label>
            Tutore legale
          <select
            onChange={event => this.setState({ tutor_id: event.target.value })}
            value={m.tutor_id}
          >
            <option value=''></option>
            {
              list.map((m, index) => {
                return (
                  <option key={index} value={m.id}>
                    {m.name} {m.surname}
                  </option>
                )
              })
            }
          </select>
        </label>
        <h4>Informazioni facoltative</h4>
        <label>
            Qualifica
          <input
            type="text"
            placeholder="Qualifica"
            onChange={event => this.setState({ title: event.target.value })}
            value={m.title}
          />
        </label>
        <label>
            Sesso
          <select
            onChange={event => this.setState({ sex: event.target.value })}
            value={m.sex}
          >
            {
              sexTypes.filter((item) => {
                return item.edit || item.edit === undefined
              }).map((o, index) => {
                return (
                  <option key={index} value={o.value}>{o.label}</option>
                )
              })
            }
          </select>
        </label>
        <label>
            CAP
          <input
            type="text"
            placeholder="CAP"
            onChange={event => this.setState({ postal_code: event.target.value })}
            value={m.postal_code}
          />
        </label>
        <label>
            Città di nascita
          <input
            type="text"
            placeholder="Città di nascita"
            onChange={event => this.setState({ born_city: event.target.value })}
            value={m.born_city}
          />
        </label>
        <label>
            Provincia di nascita
          <select
            onChange={event => this.setState({ born_country: event.target.value })}
            value={m.born_country}
          >
            <option value=''></option>
            {
              countries.map((c, index) => {
                return (
                  <option key={index} value={c.value}>
                    {c.label}
                  </option>
                )
              })
            }
          </select>
        </label>
        <h4>Contatti</h4>
        <label>
            Email
          <input
            type="email"
            placeholder="Email"
            onChange={event => this.setState({ email: event.target.value })}
            value={m.email}
          />
        </label>
        <label>
            Telefono
          <input
            type="tel"
            placeholder="Telefono"
            onChange={event => this.setState({ phone: event.target.value })}
            value={m.phone}
          />
        </label>
        <label>
            Cellulare
          <input
            type="tel"
            placeholder="Cellulare"
            onChange={event => this.setState({ mobile: event.target.value })}
            value={m.mobile}
          />
        </label>
        <h4>Informazioni corso</h4>
        <label>
            Corso
          <select
            onChange={event => this.setState({ course_id: event.target.value })}
            value={m.course_id}
          >
            <option value=''></option>
            {
              this.props.courses.list.map((m, index) => {
                return (
                  <option key={index} value={m.id}>
                    {m.name}
                  </option>
                )
              })
            }
          </select>
        </label>
        <label>
            Taglia T-shirt
          <select
            onChange={event => this.setState({ tshirt_size: event.target.value })}
            value={m.tshirt_size}
          >
            {
              tshirtSizes.filter((item) => {
                return item.edit || item.edit === undefined
              }).map((o, index) => {
                return (
                  <option key={index} value={o.value}>{o.label}</option>
                )
              })
            }
          </select>
        </label>
        <label>
            Data scadenza assicurazione
          <input
            type="date"
            placeholder="Data scadenza assicurazione"
            onChange={event => this.setState({ insurance_date: event.target.value })}
            value={m.insurance_date}
          />
        </label>
        <h4>Certificato medico</h4>
        <label>
            Scadenza certificato medico
          <input
            type="date"
            placeholder="Data scadenza certificato medico"
            onChange={event => this.setState({ medical_certificate: event.target.value })}
            value={m.medical_certificate}
          />
        </label>
        <label>
          Allega certificato medico
          <input type="file"
            ref={(ref) => (this.upload = ref)}
            onChange={this._handleImageChange}
          />
        </label>
        {
          (m.medical_certificate_checksum !== '') && (
            <label className="check-container">
              Elimina certificato medico precedentemente caricato
              <input type="checkbox"
                disabled={m.doc_delete_lock ? 'disabled' : ''}
                onChange={event => this.setState({ doc_delete: event.target.checked })}
                value={m.doc_delete}
                checked={m.doc_delete}
              />
              <span className="checkmark"></span>
            </label>
          )
        }
        <label>
            Aggiungi immagine socio
          <input type="file"
            ref={(ref) => (this.uploadAvatar = ref)}
            onChange={this._handleAvatarChange}
          />
        </label>
        <label>
            Note
          <textarea placeholder="Note"
            onChange={event => this.setState({ notes: event.target.value })}
            value={m.notes}
          ></textarea>
        </label>
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.saveMembers()}
            >
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveMembers, startUpload, stopUpload, clearAjaxCall, saveMembersFailure })(EditMember)



// WEBPACK FOOTER //
// ./src/components/Members/EditMember.js